import React from "react";
import { Col, Row } from "reactstrap";
import { CustomLabel, ErrorMessage } from "../../../utilities/utll";
import {
  EyeInvisibleOutlined,
  EyeOutlined,
  LockOutlined,
  ReloadOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Button, Input, Select } from "antd";
import LuxuryCheckbox from "../../../common/Checkbox";

export const RegisterForm = ({
  formData,
  handleChange,
  errors,
  showPassword,
  toggleShow,
  handleSave,
  handleReset,
  roleData,
  storeData,
  employeesData,
  divisionData,
  departmentData,
  loadingDepartments,
}) => {
  return (
    <>
      <Row>
        <Col xl={3} md={6} sm={12}>
          <CustomLabel children={"Name"} isImportnt={true} />
          <Input
            name="name"
            id="name"
            type="text"
            placeholder="Enter Name"
            size="medium"
            value={formData?.name ?? ""}
            onChange={(e) => handleChange("name", e.target.value)}
            status={errors?.name ? "error" : ""}
          />
          <ErrorMessage error={errors?.name} />
        </Col>
        <Col xl={3} md={6} sm={12}>
          <CustomLabel children={"User Name"} isImportnt={true} />
          <Input
            name="userName"
            id="userName"
            type="text"
            placeholder="Enter User Name"
            size="medium"
            value={formData?.userName ?? ""}
            onChange={(e) => handleChange("userName", e.target.value)}
            status={errors?.userName ? "error" : ""}
          />
          <ErrorMessage error={errors?.userName} />
        </Col>
        <Col xl={3} md={6} sm={12}>
          <CustomLabel children={"Password"} isImportnt={true} />

          <Input
            name="password"
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter Password"
            value={formData?.password ?? ""}
            onChange={(e) => handleChange("password", e.target.value)}
            status={errors?.password ? "error" : ""}
            prefix={<LockOutlined style={{ color: "#bfbfbf" }} />}
            suffix={
              <button
                type="button"
                onMouseDown={(e) => e.preventDefault()}
                onClick={toggleShow}
                aria-label={showPassword ? "Hide password" : "Show password"}
                style={{
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
              </button>
            }
          />
          <ErrorMessage error={errors?.password} />
        </Col>
        <Col xl={3} md={6} sm={12}>
          <CustomLabel children={"Email"} isImportnt={true} />
          <Input
            name="email"
            id="email"
            type="text"
            placeholder="Enter Email"
            size="medium"
            value={formData?.email ?? ""}
            onChange={(e) => handleChange("email", e.target.value)}
            status={errors?.email ? "error" : ""}
          />
          <ErrorMessage error={errors?.email} />
        </Col>
      </Row>
      <Row>
        <Col xl={3} lg={3} md={6}>
          <CustomLabel children={"Employee"} isImportnt={true} />
          <Select
            id="employeeID"
            placeholder="Select Employee"
            value={formData?.employeeID}
            onChange={(e) => handleChange("employeeID", e)}
            options={employeesData.map((emp) => ({
              value: emp.ID,
              label: emp.FirstName + " " + emp.LastName,
            }))}
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            status={errors.employeeID ? "error" : ""}
          />
          <ErrorMessage error={errors.employeeID} />
        </Col>
        <Col xl={3} lg={3} md={6}>
          <CustomLabel children={"Role"} isImportnt={true} />
          <Select
            id="roleId"
            placeholder="Select Role"
            value={formData?.roleId}
            onChange={(e) => handleChange("roleId", e)}
            options={roleData.map((emp) => ({
              value: emp.RoleId,
              label: emp.RoleName,
            }))}
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            status={errors.roleId ? "error" : ""}
          />
          <ErrorMessage error={errors.roleId} />
        </Col>
        <Col xl={3} lg={3} md={6}>
          <CustomLabel children={"Store"} isImportnt={true} />
          <Select
            id="storeId"
            placeholder="Select Store"
            mode="multiple"
            value={formData?.storeId}
            onChange={(e) => handleChange("storeId", e)}
            options={[
              {
                value: "all",
                label: "Select All",
              },
              ...storeData.map((store) => ({
                value: store.StoreCode,
                label: store.StoreName,
              })),
            ]}
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            status={errors.storeId ? "error" : ""}
            maxTagCount="responsive"
          />
          <ErrorMessage error={errors.storeId} />
        </Col>
        <Col xl={3} lg={3} md={6}>
          <CustomLabel children={"Division"} isImportnt={true} />
          <Select
            id="divisionId"
            placeholder="Select Division"
            mode="multiple"
            value={formData?.divisionId}
            onChange={(e) => handleChange("divisionId", e)}
            options={[
              {
                value: "all",
                label: "Select All",
              },
              ...divisionData.map((division) => ({
                value: division.Division,
                label: division.DivisionName,
              })),
            ]}
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            status={errors.divisionId ? "error" : ""}
            maxTagCount="responsive"
          />
          <ErrorMessage error={errors.divisionId} />
        </Col>
      </Row>
      <Row>
        <Col xl={3} lg={3} md={6}>
          <CustomLabel children={"Department"} isImportnt={true} />
          <Select
            id="departmentId"
            placeholder="Select Department"
            mode="multiple"
            value={formData?.departmentId}
            onChange={(e) => handleChange("departmentId", e)}
            options={[
              {
                value: "all",
                label: "Select All",
              },
              ...departmentData.map((dept) => ({
                value: dept.Department,
                label: dept.DepartmentName,
              })),
            ]}
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            status={errors.departmentId ? "error" : ""}
            maxTagCount="responsive"
            loading={loadingDepartments}
            disabled={!formData?.divisionId || formData.divisionId.length === 0}
          />
          <ErrorMessage error={errors.departmentId} />
        </Col>
        <Col
          xl={3}
          md={6}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "1rem",
            gap: "10px",
          }}
        >
          <LuxuryCheckbox
            id="isActive"
            label="IsActive"
            checked={formData?.isActive}
            onChange={() => handleChange("isActive", !formData?.isActive)}
          />
        </Col>
        <Col
          xl={3}
          md={6}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "1rem",
            gap: "10px",
          }}
        >
          <LuxuryCheckbox
            id="approverRights"
            label="Approver Rights"
            checked={formData?.approverRights}
            onChange={() => handleChange("approverRights", !formData?.approverRights)}
          />
        </Col>
        <Col
          xl={9}
          md={6}
          sm={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", gap: "10px", marginTop: "1rem" }}>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              size="medium"
              style={{
                backgroundColor: "#52c41a",
                borderColor: "#52c41a",
                boxShadow: "0 2px 6px rgba(82, 196, 26, 0.3)",
              }}
              onClick={handleSave}
            >
              {formData?.userId === 0 ? "Submit" : "Update"}
            </Button>
            <Button
              icon={<ReloadOutlined />}
              size="medium"
              style={{
                borderColor: "#ff1818ff",
                color: "#ff1818ff",
              }}
              onClick={handleReset}
            >
              Reset
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
};
